/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Outgoing',
  components: {},
  data () {
    return {
      callTimeout: null,
      noAnswer: false,
      callEnded: false,
      contact: {
        callstatus: 'calling',
        userhash: 'wqewqerqwjrhwefjbcajsfcjafsdfnvjdnvjsnjn',
        name: 'Abhilash S',
        title: 'Designer',
        room: 780000
      }
    };
  },
  computed: {
    ...mapGetters('AppStore', {
      micMuted: 'micMuted',
      inPhoneCall: 'inPhoneCall'
    }),
    ...mapGetters('AuthStore', {
      user: 'profile'
    }),
    // ...mapGetters('ContactStore', {
    //   contact: 'outgoingContact'
    // }),
    showControls () {
      return !(
        this.callEnded ||
        this.noAnswer ||
        this.contact.callstatus === 'accepted' ||
        this.contact.callstatus === 'rejected'
      );
    },
    myEndPoint () {
      return this.user &&
        this.user.myendpoint &&
        this.user.myendpoint.trim().length > 0
        ? this.user.myendpoint
        : null;
    }
  },
  created () {
    this.$_NATIVE.playAudio({ type: 'dial', loop: true });
  },
  mounted () {
    // if (!this.user) {
    //   this.$eventBus.$emit('make-free-call', this.contact);
    // } else {
    //   this.$eventBus.$emit('make-call', this.contact);
    // }
    // let self = this;
    // self.callTimeout = setTimeout(() => {
    //   self.$eventBus.$emit('sendToControls', {
    //     type: 'input',
    //     scope: 'outgoing',
    //     data: {
    //       field: 'noAnswer',
    //       value: true
    //     }
    //   });
    //   self.noAnswer = true;
    //   self.exitMeeting();
    //   self.exitCall();
    //   this.$eventBus.$emit('remove-calling-screen', { noDelay: false, enableAutoRotate: false });
    //   self.$_NATIVE.outgoingCallTimeout();
    // }, self.$_GLOBAL.Timers.CALL_TIMEOUT);
    this.$eventBus.$on('native-messageFromControl', this.onMessageFromControl);
    this.$eventBus.$on('phone-call-status', this.onPhoneCallStatus);
  },
  beforeDestroy () {
    this.clearCallTimeout();
    this.$_NATIVE.stopAudio('dial');
    this.$eventBus.$emit('fetch-recent-calls');
    this.$eventBus.$off('native-messageFromControl', this.onMessageFromControl);
    this.$eventBus.$off('phone-call-status', this.onPhoneCallStatus);
  },
  methods: {
    ...mapActions('AppStore', {
      setMicMuted: 'setMicMuted'
    }),
    clearCallTimeout () {
      if (this.callTimeout) {
        clearTimeout(this.callTimeout);
      }
    },
    endCall (mouseMovement, fromControl = false) {
      if (!fromControl) {
        this.$eventBus.$emit('sendToControls', {
          type: 'task',
          scope: 'outgoing',
          data: {
            task: 'endCall'
          }
        });
      }
      this.callEnded = true;
      this.$eventBus.$emit('end-call', {
        userhash: this.contact.userhash
      });
      this.exitMeeting();
      this.exitCall();
    },
    exitCall () {
      this.$eventBus.$emit('sendToControls', {
        type: 'task',
        scope: 'outgoing',
        data: {
          task: 'exitCall'
        }
      });
      this.clearCallTimeout();
      this.$_NATIVE.stopAudio('dial');
    },
    exitMeeting () {
      if (!this.user) {
        this.$eventBus.$emit('native-exitMeeting', {});
      }
    },
    muteMic () {
      this.$eventBus.$emit('sendToControls', {
        type: 'task',
        scope: 'outgoing',
        data: {
          task: 'setMicMuted',
          param: !this.micMuted
        }
      });
      this.setMicMuted(!this.micMuted);
    },
    onMessageFromControl ({ message }) {
      try {
        if (message.scope === 'outgoing') {
          if (message.type === 'task') {
            switch (message.data.task) {
              case 'endCall':
                this.endCall(null, true);
                break;
              case 'setMicMuted':
                this.setMicMuted(message.data.param);
                break;
            }
          }
        }
      } catch (err) {}
    },
    onPhoneCallStatus () {
      if (this.inPhoneCall) {
        this.endCall();
      }
    }
  }
};
